import { createFileRoute } from "@tanstack/react-router";
import { CustomerComparer } from "../../app/views/customerComparer/customerComparer";

export const Route = createFileRoute("/customer/duplicates")({
  component: CustomerComparer,
});
